// extracted by mini-css-extract-plugin
module.exports = {"containerRoot":"error_containerRoot__XTiCy","imgError":"error_imgError__AN8sX","textError":"error_textError__GCfkp","btnTryAgain":"error_btnTryAgain__7MXLc"};